import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { BaseCardComponent } from '../cards/base-card/base-card.component';

@Component({
  selector: 'ui-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SpinnerComponent, NzSkeletonModule, BaseCardComponent],
  template: `
    @if (loading()) {
      <div class="flex justify-center items-center h-full w-full">
        @switch (loadingType()) {
          @case ('spinner') {
            <ui-spinner [isLoading]="loading()"></ui-spinner>
          }
          @case ('skeleton') {
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          }
          @case ('skeletonCard') {
            <ui-base-card class="w-full h-full" [width]="'full'">
              <ng-container content>
                <nz-skeleton [nzActive]="true"></nz-skeleton>
              </ng-container>
            </ui-base-card>
          }
          @default {
            <div>
              <p>Unknown loading type: {{ loadingType() }}</p>
            </div>
          }
        }
      </div>
    } @else {
      <ng-content></ng-content>
    }
  `,
})
export class LoaderWrapperComponent {
  /** Indicates whether the loader is active */
  loading = input.required<boolean>();

  /** Specifies the type of loader to display */
  loadingType = input<'spinner' | 'skeleton' | 'skeletonCard'>('spinner');
}
